import ListingPage from '../index';

export default ListingPage;
